export const SHOW_SCHEDULE_MODAL = 'SHOW_SCHEDULE_MODAL';
export const CLOSE_SCHEDULE_MODAL = 'CLOSE_SCHEDULE_MODAL';
